<template>
  <v-container class="mt-0 pt-0 pl-0 ptoContainer">
    <v-alert
      v-if="ptoInfo['showBalanceBadge']"
      border="top"
      colored-border
      type="info"
      elevation="2"
      class="mt-5"
    >
      <span v-if="ptoInfo['p_cfm_prev']">Please note, you must confirm your PTO. </span
      ><span v-if="ptoInfo['p_cfm_this_month']">You have unconfirmed PTO.</span> Please
      review each PTO type below and confirm your dates
      taken.&nbsp;&nbsp;&nbsp;
      <PtoConfirm v-if="afterCreated == true" :pto="pto" :ptoInfo="ptoInfo" />
    </v-alert>

    <v-alert
      v-if="this.$router.currentRoute.path.includes('balanceNext')"
      border="top"
      colored-border
      type="info"
      elevation="2"
      class="mt-5"
    >
    Your available PTO for next fiscal year is displayed below.  Potential carryover days are not included since available days may change.  Please be assured when the system is updated for the new year, all available carryover days will be reflected. 
    </v-alert>

    <v-alert
      v-if="this.site_status == 'prev_and_cur_year' && this.$router.currentRoute.path.slice(-7) == 'balance'"
      border="top"
      colored-border
      type="info"
      elevation="2"
      class="mt-5"
    >
      Potential carryover days are not included below.  Please be assured when the system is updated for FY 2025-26, all available carryover days will be reflected. 
    </v-alert>

    <v-row class="mt-0 pt-0">
      <v-col class="mt-0 pt-0">
        <div>
          <span style="display: none">{{ this.pto_data.firstname }}</span>
          <v-expansion-panels multiple flat>
            <v-expansion-panel v-for="(cat, i) in pto_to_show" :key="i">
              <v-expansion-panel-header v-if="showCategory(cat.name_code, cat.taken_info_array, cat.scheduled_info_array)">{{
                cat.name_plural
              }}</v-expansion-panel-header>
              <!--
              <v-expansion-panel-header v-if="cat.name && (cat.taken_info_array.length >= 0 || cat.scheduled_info_array.length >= 0)">{{
                cat.name_plural
              }}</v-expansion-panel-header>
              -->
              <v-expansion-panel-content class="table">
                  <v-layout row wrap class="tr" v-if="cat.carr_over > 0">
                    <v-flex xs12 md3 class="td_left">Carried Over</v-flex>
                    <v-flex xs12 md6 class="td_center hidden-md-and-down"> &nbsp; </v-flex>
                    <v-flex xs12 md3 class="td_right">{{ cat.carr_over }}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="tr" v-if="cat.limit">
                    <v-flex xs12 md3 class="td_left">Limit</v-flex>
                    <v-flex xs12 md6 class="td_center hidden-md-and-down"> &nbsp; </v-flex>
                    <v-flex xs12 md3 class="td_right">{{ cat.limit }}<span v-if="cat.name_code == 'prenatal'">h</span></v-flex>
                  </v-layout>
                  <v-layout row wrap class="tr" v-if="cat.accrued > 0">
                    <v-flex xs12 md3 class="td_left">Accrued</v-flex>
                    <v-flex xs12 md6 class="td_center  hidden-md-and-down">&nbsp;</v-flex>
                    <v-flex xs12 md3 class="td_right">{{ cat.accrued }}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="tr" >
                    <v-flex xs12 md3 class="td_left">Dates Taken</v-flex>
                    <v-flex xs12 md6 class="td_center">
                      <span v-for="(taken, j) in cat.taken_info_array" :key="j">                        
                        <v-tooltip left v-if="cat.taken_status_array[j]">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="is_NYPFL( cat.taken_full_partial_array[j])"
                              class="icon-circle-green"
                              aria-label="NYPFL"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-minus-circle</v-icon
                            >
                            <v-icon
                              v-else-if="cat.taken_status_array[j] == 'Confirmed'"
                              class="icon-circle-green"
                              aria-label="Employee Confirmed"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span v-if="is_NYPFL( cat.taken_full_partial_array[j])"
                            >NYPFL</span
                          >
                          <span v-else-if="cat.taken_status_array[j] == 'Confirmed'"
                            >Employee Confirmed</span
                          >
                          <span v-else>Pending Employee Confirmation</span>
                        </v-tooltip> 
                        {{ taken }} 
                        <span v-if="is_NYPFL( cat.taken_full_partial_array[j] )" class="day_type_nypfl"></span> 
                        <br />
                      </span>
                    </v-flex>
                    <v-flex xs12 md3 class="td_right">{{ cat.taken_total_num }}<span v-if="cat.name_code == 'prenatal'">h</span></v-flex>
                  </v-layout>
                  <v-layout row wrap class="tr">
                    <v-flex xs12 md3 class="td_left">Scheduled Dates</v-flex>
                    <v-flex xs12 md6 class="td_center">
                      <span
                        v-for="(scheduled, k) in cat.scheduled_info_array"
                        :key="k"
                      >
                        <v-tooltip left v-if="cat.scheduled_status_array[k]">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="
                                cat.scheduled_status_array[k] == 'Confirmed'
                              "
                              class="icon-circle-green"
                              aria-label="NYFPL or Disability PTO"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-minus-circle</v-icon
                            >
                            <v-icon
                              v-else-if="
                                cat.scheduled_status_array[k] == 'Approved'
                              "
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Employee Confirmation"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                            <v-icon
                              v-else
                              class="icon-circle-gray icon-white"
                              aria-label="Pending Manager Approval"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-timer-sand</v-icon
                            >
                          </template>
                          <span
                            v-if="cat.scheduled_status_array[k] == 'Confirmed'"
                            >NYPFL or Disability</span
                          >
                          <span
                            v-else-if="
                              cat.scheduled_status_array[k] == 'Approved'
                            "
                            >Pending Employee Confirmation</span
                          >
                          <span v-else>Pending Manager Approval</span>
                        </v-tooltip> 
                        {{ scheduled }} 
                        <span v-if="is_NYPFL( cat.scheduled_full_partial_array[k] )" class="day_type_nypfl"></span>  
                        <br />
                      </span>
                    </v-flex>
                    <v-flex xs12 md3 class="td_right">
                      {{ cat.scheduled_total_num }}<span v-if="cat.name_code == 'prenatal'">h</span>
                      <PtoChange
                        v-if="cat.scheduled_total_num > 0 && cat.scheduled_total_num > cat.scheduled_total_leave_of_absence_num "
                        :pto="pto"
                        :ptoChange_scroll_to="ptoChange_scroll_to"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="tr" v-if="cat.remain_total >= 0">
                    <v-flex xs12 md3 class="td_left font-weight-bold">Remaining</v-flex>
                    <v-flex xs12 md6 class="td_center hidden-md-and-down"> &nbsp; </v-flex>
                    <v-flex xs12 md3 class="td_right font-weight-bold">{{ cat.remain_total }}<span v-if="cat.name_code == 'prenatal'">h</span></v-flex>
                  </v-layout>
              </v-expansion-panel-content>   
            </v-expansion-panel>

            <!-- Disputes and Denied -->
            <v-expansion-panel  v-if="pto_to_show.denied_info_array || pto_to_show.disputed_info_array">
              <v-expansion-panel-header >Denied and Disputed</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <v-layout row wrap class="staff_pto_head pt-2 pb-2 hidden-md-and-down" >
                    <v-flex xs12 md2 class="staff_pto_col_left"> Type: </v-flex>
                    <v-flex xs12 md3 class="staff_pto_col_center"> Date: </v-flex>
                    <v-flex xs12 md7 class="staff_pto_col_right"> Reason: </v-flex>
                  </v-layout>
                <div v-if="pto_to_show.denied_info_array && pto_to_show.denied_info_array.length > 0"> 
                 <v-layout row wrap class="staff_pto pt-2 pb-2" v-for="(denied, x) in pto_to_show.denied_info_array" :key="x">
                    <v-flex xs12 md2 class="staff_pto_col staff_pto_col_left">Denied</v-flex>
                    <v-flex xs12 md3 class="staff_pto_col staff_pto_col_center"> {{ denied.date }} </v-flex>
                    <v-flex xs12 md7 class="staff_pto_col staff_pto_col_right"> {{ denied.reason}} </v-flex>
                  </v-layout>
                </div>
                <div v-if="pto_to_show.disputed_info_array && pto_to_show.disputed_info_array.length > 0"> 
                  <!-- If total denied requests == odd number, two gray rows would appeare together. Avoid with a hidden staff_pto row. -->
                   <v-layout v-if="pto_to_show.denied_info_array && pto_to_show.denied_info_array.length > 0 && pto_to_show.denied_info_array.length % 2 == 1" row wrap class="staff_pto pt-2 pb-2" style="display:none;">
                    <v-flex>&nbsp;</v-flex>
                  </v-layout>
                  <v-layout row wrap class="staff_pto pt-2 pb-2" v-for="(disputed, x) in pto_to_show.disputed_info_array" :key="x">
                    <v-flex xs12 md2 class="staff_pto_col_left">Disputed</v-flex>
                    <v-flex xs12 md3 class="staff_pto_col_center"> {{ disputed.date }} </v-flex>
                    <v-flex xs12 md7 class="staff_pto_col_right"> {{ disputed.reason}} </v-flex>
                  </v-layout>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import pto_func from "@/pto_functions";
import PtoChange from "./PtoChange";
import PtoConfirm from "./PtoConfirm";

export default {
  components: { PtoChange, PtoConfirm },

  props: ["ptoInfo"],

  data: () => ({
    pto_cat_names: [],
    pto_cat_plurals: [],
    pto_cat_codes: [],

    saas_data: [null],
    pto_data: [null],
    afterCreated: false,
    cur_fiscal_year: pto_func.get_fiscal_year("cur_long"),
    next_fiscal_year: pto_func.get_fiscal_year("next_long"),
    prev_fiscal_year: pto_func.get_fiscal_year("prev_long"),
    site_status: pto_func.get_site_status(),
    ptoChange_scroll_to: null, // If it's current year, do not scroll, stay on top of page

    pto_to_show: {
      vacation: {
        name: "",
        name_plural: "",
        name_code: "",
        limit: 0,
        remain: 0,
        accrued: 0,
        carr_over: 0,
        carr_over_remain: 0,
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
        requested: [],
      },
      sick: {
        name: "",
        name_plural: "",
        name_code: "",
        limit: 0,
        remain: 0,
        accrued: 0,
        carr_over: 0,
        carr_over_remain: 0,
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
        requested: [],
      },
      holiday: {
        name: "",
        name_plural: "",
        name_code: "",
        limit: 0,
        remain: 0,
        accrued: 0,
        carr_over: 0,
        carr_over_remain: 0,
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
        requested: [],
      },
      personal: {
        name: "",
        name_plural: "",
        name_code: "",
        limit: 0,
        remain: 0,
        accrued: 0,
        carr_over: 0,
        carr_over_remain: 0,
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
        requested: [],
      },
      bereavement: {
        name: "",
        name_plural: "",
        name_code: "",
        requested: [],
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
      },
      prenatal: {
        name: "",
        name_plural: "",
        name_code: "",
        requested: [],
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
      },

      jury_duty: {
        name: "",
        name_plural: "",
        name_code: "",
        requested: [],
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
      },
      covid: {
        name: "",
        name_plural: "",
        name_code: "",
        requested: [],
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
      },
      covid_sick: {
        name: "",
        name_plural: "",
        name_code: "",
        requested: [],
        taken_total_num: 0,
        taken_dates_array: [],
        taken_full_partial_array: [],
        taken_info_array: [],
        taken_status_array: [],
        scheduled_info_array: [],
        scheduled_status_array: [],
        scheduled_total_num: [],
        scheduled_total_leave_of_absence_num: [],
        scheduled_dates_array: [],
        scheduled_full_partial_array: [],
        scheduled_ids: [],
        remain_total: 0,
      },
    },
  
    pto: pto_func.pto_set_format(),
  }),

  created() {

   if (this.ptoInfo['showReqBalTab'] == false ) {   
      // faculty approver cannot make pto request
      this.$router.push({
          path: "/pto/manager",
        });
        return false;
    }

    //if (this.site_status == "prev_and_cur_year" || this.site_status == "roll_data") {
    if (pto_func.show_prev_balance()) {  
      // PtoChange needs data for prev fiscal year, populate here
      axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.prev_fiscal_year).then((response) => {
        this.saas_data = response.data;
        this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.prev_fiscal_year);
        this.pto_data['firstname'] = this.pto_data[this.prev_fiscal_year]['firstname'];
        this.pto_data['lastname'] = this.pto_data[this.prev_fiscal_year]['lastname'];
      }).catch(error => {
          window.console.error(error);
      });
    }

    axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.cur_fiscal_year).then((response) => {
      this.saas_data = response.data;
      this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.cur_fiscal_year);
      this.pto_data['firstname'] = this.pto_data[this.cur_fiscal_year]['firstname'];
      this.pto_data['lastname'] = this.pto_data[this.cur_fiscal_year]['lastname'];
      this.pto_to_show = this.pto_data[this.cur_fiscal_year];
    }).catch(error => {
          window.console.error(error);
      });

    if (this.site_status == "cur_and_next_year") {
      // PtoChange needs data for next fiscal year, populate here
      axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+this.next_fiscal_year).then((response) => {
        this.saas_data = response.data;
        this.pto_data = pto_func.fy_formatEmpPto(this.saas_data, this.pto, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, this.next_fiscal_year);
        this.pto_data['firstname'] = this.pto_data[this.next_fiscal_year]['firstname'];
        this.pto_data['lastname'] = this.pto_data[this.next_fiscal_year]['lastname'];
        //if (this.$router.currentRoute.path.includes('balanceNext')) {
        //  this.pto_to_show = this.pto_data[this.next_fiscal_year];
        //  this.ptoChange_scroll_to = this.next_fiscal_year;
        //}
      }).catch(error => {
          window.console.error(error);
      });
    }
    
    this.afterCreated = true;

  },

  updated() {
    // Sometimes when refreshing the page, balanceNext tab would load balance/current pto.
    // Move following code from created() to updated(), seems to fix the issue
    if (this.site_status == "cur_and_next_year" && this.$router.currentRoute.path.includes('balanceNext')) {
        this.pto_to_show = this.pto_data[this.next_fiscal_year];
        this.ptoChange_scroll_to = this.next_fiscal_year;
    } else if (pto_func.show_prev_balance() && this.$router.currentRoute.path.includes('balancePrev')) {
        this.pto_to_show = this.pto_data[this.prev_fiscal_year];
        this.ptoChange_scroll_to = this.prev_fiscal_year;
    } else {
      this.pto_to_show = this.pto_data[this.cur_fiscal_year];
      this.ptoChange_scroll_to = this.cur_fiscal_year;      
    }

  },

  mounted() {
    this.pto_cat_names = pto_func.getPtoCats("names");
    this.pto_cat_plurals = pto_func.getPtoCats("plurals");
    this.pto_cat_codes = pto_func.getPtoCats("codes");
  },

  methods: {
    showCategory(cat_code, taken, scheduled) {
      if (!cat_code)
        return false;
      let pto_mgr_appr_codes = pto_func.getPtoCats("pto_mgr_appr_codes"); 
      for (var i = 0; i < pto_mgr_appr_codes.length ; i++) {
        if (pto_mgr_appr_codes[i].includes(cat_code))
          return true;        
      }
      // categories do not require approval:
      if (taken && taken.length > 0 )
        return true;
      else if (scheduled && scheduled.length > 0 )
        return true;
      else 
        return false;     
    },

    is_NYPFL (dayType) {
      return pto_func.is_NYPFL(dayType);
    }

  },

};
</script>

<style scoped>
.ptoContainer {
  margin-left: -12px !important;
  margin-top: -45px !important;
}

.v-expansion-panels {
  width: 100%;
}

.v-expansion-panel-header {
  border-bottom: 1px solid #ffb500;
  font-weight: bold;
  font-size: 1.1em;
  margin-top: 25px !important;
}

.panel_content {
  font-weight: normal;
  padding: 20px 24px;
  border-top: 1px solid #aaa;
}

.panel_content:first-child {
  border-top: 0 !important;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.tr {
  padding-bottom: 0 !important ;
  margin-left: 2px;
  margin-right: 2px;
  border-bottom: 1px solid #aaa;
}

.table .tr:nth-child(even) {background: #fff }
.table .tr:nth-child(odd) {background: #eee }
.table .tr:first-child {border-top: 0 !important }
.table .tr:last-child {border-bottom: 1px solid #aaa }

.td_left {
  vertical-align: top;
  padding: 20px 20px 20px 55px;
}

.td_center {
  vertical-align: top;
  padding: 20px 20px;
}

.td_right {
  padding: 20px 80px 20px 20px;
  text-align: right;
  vertical-align: top;
}

.icon-circle-gray {
  background: #bbb;
  padding: 2px;
  border-radius: 50%;
}

.icon-circle-green {
  color: green;
}

.icon-circle-blue {
  color: royalblue;
}

.icon-white {
  color: #fff;
  font-size: 1.1em;
}

tr:first-child td {
  border-top: 0 !important;
}

.staff_pto,
.staff_pto_head {
  border-bottom: 1px solid #aaa !important;
  margin-left: 2px;
  margin-right: 2px;
}

.staff_pto:nth-child(even) {background: #fff }
.staff_pto:nth-child(odd) {background: #eee }
/*
.table .tr:first-child {border-top: 0 !important }
.table .tr:last-child {border-bottom: 1px solid #aaa }
*/
.staff_pto_col_left {
  vertical-align: top;
  padding: 20px 20px 20px 55px;
}

.staff_pto_col_center {
  vertical-align: top;
  padding: 20px 20px;
}

.staff_pto_col_right {
  padding: 20px 80px 20px 20px;
  vertical-align: top;
}

.day_type_nypfl::before {
  content: "\2153"; /* Unicode for 1/3 */
  font-size: 18px;
  color: #000;
}


@media only screen and (max-width: 1246px) {
  .td_left,
  .td_center,
  .td_right,
  .staff_pto_col_left,
  .staff_pto_col_center, 
  .staff_pto_col_right {
    padding: 5px 20px;
    width: 100%;
    text-align: left;
    display: block;
  } 
}

</style>